module.exports = __webpack_public_path__ + "img/wx_jsapi.835aac8f.svg";